import Loader from '../components/Loader'
import { useLoading } from './LoadingProvider'

function LoadingPlaceHolder() {
    const { loading } = useLoading()

    return loading ? <Loader /> : null
}

export default LoadingPlaceHolder
